/**
 * @module lib/eventemitter
 * @description the JavaScript in both the pattern library and the PageBuilder project
 *  must share the same event emitter instance, so we're pulling it in here.
 */

import ee from "panther/event-emitter";

export default ee;
